import { useTranslation } from 'react-i18next';

import {
  useBackUrl,
  useCategoryName,
  useSubcategoryName,
} from '@/atoms/document';

export const useBreadcrumbs = (
  goBack: (isSearch?: boolean) => void,
  isFromSearch: boolean,
  resourceIsSuccess: boolean,
) => {
  const { t } = useTranslation();
  const [categoryName] = useCategoryName();
  const [subcategoryName] = useSubcategoryName();
  const [backUrl] = useBackUrl();

  const breadcrumbs = [
    {
      label: t('Generic.explore'),
      to: '/',
    },
    {
      label: categoryName,
      to: backUrl || undefined,
      onClick: !backUrl ? () => goBack() : undefined,
    },
    {
      label: subcategoryName,
      to: backUrl || undefined,
      onClick: !backUrl ? () => goBack() : undefined,
    },
    // Design wants the chevron right icon to show at the end without a label
    {
      label: '',
    },
  ];

  const breadcrumbsFromSearch = [
    {
      label: t('Generic.search'),
      // Prefer backUrl (same as DocumentHeader) so AI/search new-tab return
      // lands on the encoded search page, not a reconstructed query.
      to: backUrl || undefined,
      onClick: !backUrl ? () => goBack(true) : undefined,
    },
    // Design wants the chevron right icon to show at the end without a label
    {
      label: '',
    },
  ];

  const breadcrumbsFromlink = [
    {
      label: t('Generic.explore'),
      to: '/',
    },
    // Design wants the chevron right icon to show at the end without a label
    {
      label: '',
    },
  ];

  return isFromSearch
    ? breadcrumbsFromSearch
    : resourceIsSuccess
      ? breadcrumbsFromlink
      : breadcrumbs;
};
